import React, {useEffect, useState} from "react";
import { StaticDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { el, enUS } from "date-fns/locale";
import { css } from "aphrodite";
import styles from "./styles";
import { Typography } from "@mui/material";
import "./style.css"
import i18n from "../../../../i18n";

const CustomStaticDatePicker = ({
    onDateChange,
    title = "Select Date",
    minDate = new Date(),
    activeDates = 30,
    availableDates = [],
}) => {
    const [value, setValue] = useState(availableDates.length > 0 ? minDate : null);

    const handleDateChange = (newValue) => {
        setValue(newValue);
        if (onDateChange) {
            onDateChange(newValue);
        }
    };

    useEffect(() => {
        if (availableDates.length > 0) {
            handleDateChange(minDate);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const isDateAvailable = (date) => {
        const dateString = date.toISOString().split('T')[0];
        return availableDates.length > 0 && availableDates.includes(dateString);
    };

    const shouldDisableDate = (date) => {
        return !isDateAvailable(date);
    };
    return (
        <div className={css(styles.container)}>
            {title && <Typography variant="h6" color="inherit">{title}</Typography>}
            <div
                className={css(
                    styles.datePickerContainer,
                )}
            >
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={(i18n?.language === "gr" ) ? el : enUS }>
                    <StaticDatePicker
                        displayStaticWrapperAs="desktop"
                        openTo="day"
                        value={value}
                        onChange={handleDateChange}
                        minDate={minDate}
                        maxDate={
                            new Date(
                                minDate.getFullYear(),
                                minDate.getMonth(),
                                minDate.getDate() + activeDates
                            )
                        }
                        shouldDisableDate={shouldDisableDate}
                        textField={(params) => <input {...params} />}
                        renderDay={(day, selectedDates, pickersDayProps) => {
                            const isAvailable = isDateAvailable(day);
                            return (
                                <div 
                                    {...pickersDayProps}
                                    style={{
                                        ...pickersDayProps.style,
                                        color: isAvailable ? 'inherit' : '#ccc',
                                        opacity: isAvailable ? 1 : 0.5,
                                    }}
                                >
                                    {day.getDate()}
                                </div>
                            );
                        }}
                        components={{
                            ActionBar: () => null,
                            OpenPickerIcon: () => null,
                            Toolbar: () => null,
                        }}
                    />
                </LocalizationProvider>
            </div>
        </div>
    );
};

export default CustomStaticDatePicker;
